import { galleryItems } from "@/mocks/home";

export default function GalleryWall() {
  return (
    <section id="gallery" className="w-full border-b border-background-200 bg-background-100">
      <div className="mx-auto w-full max-w-page px-4 py-8 md:px-6 md:py-12">
        <div className="mb-6 flex flex-col gap-3 md:flex-row md:items-end md:justify-between">
          <div>
            <span className="inline-flex items-center gap-1.5 rounded-full bg-secondary-100 px-3 py-1 text-xs text-secondary-900">
              <i className="ri-image-2-line text-secondary-700" />
              爆料图鉴
            </span>
            <h2 className="mt-3 font-heading text-3xl leading-tight text-foreground-950 md:text-4xl">
              图文并重的现场碎片
            </h2>
            <p className="mt-2 max-w-2xl text-sm text-foreground-600 md:text-base">
              被反复解读的画面都收在这里，配上一句说明，看图也能看懂上下文。
            </p>
          </div>
          <span className="flex w-fit items-center gap-1.5 whitespace-nowrap rounded-full border border-background-300 bg-background-50 px-3 py-1.5 text-xs text-foreground-600">
            <i className="ri-stack-line text-accent-600" />
            共 62 组图集
          </span>
        </div>

        <div className="grid auto-rows-[150px] grid-cols-2 gap-3 lg:auto-rows-[168px] lg:grid-cols-3">
          {galleryItems.map((item, index) => (
            <figure
              key={item.title}
              className={`group relative cursor-pointer overflow-hidden rounded-lg border border-background-200 ${
                index === 0 ? "col-span-2 row-span-2" : ""
              }`}
            >
              <img
                src={item.image}
                alt={item.imageAlt}
                className="absolute inset-0 h-full w-full object-cover object-top transition-transform duration-700 group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/15 to-transparent" />
              <figcaption className="absolute inset-x-0 bottom-0 p-3 md:p-4">
                <span className="inline-block rounded-full bg-accent-500 px-2.5 py-0.5 text-[11px] text-foreground-950">
                  {item.tag}
                </span>
                <p className="mt-1.5 line-clamp-2 font-heading text-sm leading-snug text-background-50 md:text-base">
                  {item.title}
                </p>
              </figcaption>
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
}